import { FC, ReactNode } from 'react';
import Page from '../../components/page';
import { createUseStyles } from 'react-jss';
import Card from '@/components/card';
import { Stack } from '@mui/material';

interface Props {
  children: ReactNode;
  height?: number | string;
  width?: number | string;
}

const useStyles = createUseStyles<string, { width: number | string }>({
  container: ({ width }) => ({
    margin: '8px auto',
    width: '100%',
    maxWidth: width,
    flexShrink: 0,
  }),
});

const PageCard: FC<Props> = ({ children, height = 400, width = 500 }) => {
  const styles = useStyles({ width });

  return (
    <Page>
      <Card className={styles.container}>
        <Stack alignItems="center" justifyContent="center" gap={2} minHeight={height} p={2.5}>
          {children}
        </Stack>
      </Card>
    </Page>
  );
};

export default PageCard;
